import { createFileRoute } from "@tanstack/react-router";

const LAST_UPDATED = "July 12, 2026";

export const Route = createFileRoute("/legal/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service — European Wig Luxury" },
      { name: "description", content: "The terms that govern purchases and use of europeanwigluxury.com." },
      { property: "og:title", content: "Terms of Service — European Wig Luxury" },
      { property: "og:description", content: "The terms that govern purchases and use of europeanwigluxury.com." },
      { property: "og:url", content: "https://europeanwigluxury.com/legal/terms" },
    ],
    links: [{ rel: "canonical", href: "https://europeanwigluxury.com/legal/terms" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <article className="container-luxe max-w-3xl py-16 md:py-24">
      <p className="eyebrow">Legal</p>
      <h1 className="mt-3 font-display text-4xl md:text-5xl">Terms of Service</h1>
      <p className="mt-4 text-sm text-muted-foreground">Last updated: {LAST_UPDATED}</p>

      <div className="prose-luxe mt-10 space-y-8 text-base leading-relaxed text-foreground/85">
        <section>
          <h2 className="font-display text-2xl">1. Acceptance</h2>
          <p className="mt-3">By using europeanwigluxury.com you agree to these Terms of Service. If you don't agree, please don't use the site.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">2. Products & pricing</h2>
          <p className="mt-3">Every piece is hand-tied from 100% virgin European hair. Colors, densities, and shades will vary slightly between pieces — that's a feature of natural hair, not a defect. All prices are in USD and may change without notice; the price at checkout is the price you pay.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">3. Orders & payment</h2>
          <p className="mt-3">Orders are confirmed by email once payment is authorized. We reserve the right to refuse or cancel any order, in which case we'll refund you in full.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">4. Intellectual property</h2>
          <p className="mt-3">All text, imagery, and design on this site belong to European Wig Luxury. You may not reproduce them without written permission.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">5. Limitation of liability</h2>
          <p className="mt-3">To the fullest extent permitted by law, European Wig Luxury is not liable for indirect or consequential damages arising from use of this site or our products. Our maximum liability is limited to the amount you paid for the product in question.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">6. Governing law</h2>
          <p className="mt-3">These terms are governed by the laws of the state in which European Wig Luxury operates, without regard to conflict-of-law principles.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl">7. Contact</h2>
          <p className="mt-3">Questions? Email <a className="text-bronze underline" href="mailto:care@europeanwigluxury.com">care@europeanwigluxury.com</a>.</p>
        </section>
      </div>
    </article>
  );
}
